module.exports = __webpack_public_path__ + "static/media/BabyCourse_Desktop_Main.f2d0464f.jpf";